// @flow

function normalizeIndex(index: number, length: number): number {
  if (index < 0) return length + index;
  if (index > length - 1) return index - length;
  return index;
}

export default normalizeIndex;
